import md5 from 'md5'
export function guid(): string {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
    const r = (Math.random() * 16) | 0,
      v = c == 'x' ? r : (r & 0x3) | 0x8

    return v.toString(16)
  })
}
/* export function getImg(url: string): string {
  return new URL(`../assets/images/${url}.png`, import.meta.url).href
} */
export function getImg(url: string, type = 'png'): string {
  const file = url + '.' + type
  return new URL(`../assets/images/${file}`, import.meta.url).href
}
// 暂定svg专用
export function getfileByUrl(url: string): string {
  //let baseURL = import.meta.env.MODE === 'development'? '/api/' : '/'
  const baseURL =
    import.meta.env.MODE === 'development' ? '/src/assets/images/' : '/'
  return baseURL + url
}
export function getPercents(num: number, total: number, keep = 2): string {
  if (total == 0) return 0 + '%'
  return Math.round((num / total) * 10 ** keep) / 10 ** (keep - 2) + '%'
}
export function percentsNum(num: number, total: number, keep = 2): Number {
  if (total == 0) return 0
  return Math.round((num / total) * 10 ** keep) / 10 ** (keep - 2)
}
//全屏显示/全屏退出
export function launchFullScreen() {
  const isFullScreen =
    document.fullscreenElement ||
    document.mozFullScreenElement ||
    document.webkitFullscreenElement
  if (!isFullScreen) {
    if (document.body.requestFullscreen) {
      document.body.requestFullscreen()
    } else if (document.body.mozRequestFullScreen) {
      document.body.mozRequestFullScreen()
    } else if (document.body.webkitRequestFullscreen) {
      document.body.webkitRequestFullscreen()
    } else if (document.body.msRequestFullscreen) {
      document.body.msRequestFullscreen()
    }
  } else {
    if (document.exitFullscreen) {
      document.exitFullscreen()
    } else if (document.mozCancelFullScreen) {
      document.mozCancelFullScreen()
    } else if (document.webkitExitFullscreen) {
      document.webkitExitFullscreen()
    }
  }
}
// 防抖
export function debounce(func, delay) {
  let timer
  // 难点返回事件绑定函数
  return function () {
    // func指定this
    const context = this
    // func参数
    const args = arguments
    // 先清除定时器
    clearTimeout(timer)
    //设置定时器
    timer = setTimeout(() => {
      // 调用函数
      func.apply(context, args)
    }, delay)
  }
}
// 导出文件流形式的excel
export function excelByBlob(data, name) {
  const xlsx = 'application/vnd.ms-excel'
  const blob = new Blob([data], { type: xlsx })
  //转换数据类型
  const a = document.createElement('a') // 转换完成，创建一个a标签用于下载
  a.download = `${name}.xls`
  a.href = window.URL.createObjectURL(blob)
  a.click()
  a.remove()
}
// 根据url下载文件
export function downloadFile(path, name) {
  const xhr = new XMLHttpRequest()
  xhr.open('get', path)
  xhr.responseType = 'blob'
  xhr.send()
  xhr.onload = function () {
    if (this.status === 200 || this.status === 304) {
      // 如果是IE10及以上，不支持download属性，采用msSaveOrOpenBlob方法，但是IE10以下也不支持msSaveOrOpenBlob
      if ('msSaveOrOpenBlob' in navigator) {
        navigator.msSaveOrOpenBlob(this.response, name)
        return
      }
      const url = URL.createObjectURL(this.response)
      const a = document.createElement('a')
      a.style.display = 'none'
      a.href = url
      a.download = name
      document.body.appendChild(a)
      a.click()
      document.body.removeChild(a)
      URL.revokeObjectURL(url)
    }
  }
}
//自定义列表序列号
export function indexFn(index: Number, pageNum: Number, pageSize: Number) {
  return Number(pageNum) > 1
    ? Number(pageNum - 1) * Number(pageSize) + Number(index) + 1
    : Number(index) + 1
}
// 加密
export function encryptByMd5(password: string) {
  return md5(password).toString()
}
//计算机时间 yyyy-mm-dd hh:ms:mf
export function getDateTime() {
  const yy = new Date().getFullYear()
  const mm = new Date().getMonth() + 1
  const dd = new Date().getDate()
  // let week = new Date().getDay()
  const hh =
    new Date().getHours() < 10
      ? '0' + new Date().getHours()
      : new Date().getHours()
  const ms =
    new Date().getSeconds() < 10
      ? '0' + new Date().getSeconds()
      : new Date().getSeconds()
  const mf =
    new Date().getMinutes() < 10
      ? '0' + new Date().getMinutes()
      : new Date().getMinutes()
  return yy + '-' + mm + '-' + dd + ' ' + hh + ':' + mf + ':' + ms
}